import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "mx-4 w-full max-w-md rounded-xl bg-white p-8 shadow-2xl" }
const _hoisted_2 = { class: "mb-6 text-center" }
const _hoisted_3 = { class: "mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-red-100" }
const _hoisted_4 = { class: "mb-8 text-center text-sm text-gray-600" }
const _hoisted_5 = { class: "flex justify-center" }
const _hoisted_6 = { key: 1 }

import { onMounted, onUnmounted, ref } from 'vue';
    import { useRouter } from 'vue-router';
    import { useAuthStore } from '@/store/auth';
    import { useFraudAlert } from '@/composables/useFraudAlert';
    import { LoaderCircle, TriangleAlert } from 'lucide-vue-next';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'FraudAlertModal',
  setup(__props) {

    const router = useRouter();
    const { isFraudAlertOpen, fraudMessage, showFraudAlert, dismissFraudAlert } = useFraudAlert();
    const authStore = useAuthStore();
    const isLoggingOut = ref(false);

    const handleFraudEvent = (event: Event) => {
        const detail = (event as CustomEvent).detail;
        showFraudAlert(detail.message);
    };

    onMounted(() => {
        window.addEventListener('fraud-alert', handleFraudEvent);
    });

    onUnmounted(() => {
        window.removeEventListener('fraud-alert', handleFraudEvent);
    });

    const handleLogout = async () => {
        if (isLoggingOut.value) return;
        isLoggingOut.value = true;
        try {
            await authStore.logout();
            dismissFraudAlert();
            router.push('/landing-page');
        } catch {
            dismissFraudAlert();
            router.push('/landing-page');
        }
    };

return (_ctx: any,_cache: any) => {
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_unref(isFraudAlertOpen))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 z-[9999] flex items-center justify-center bg-black/60",
          onClick: _withModifiers(() => {}, ["self"])
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_unref(TriangleAlert), { class: "h-8 w-8 text-red-600" })
              ]),
              _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "text-lg font-semibold text-gray-900" }, "Account Alert", -1))
            ]),
            _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(fraudMessage)), 1),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_base_button, {
                size: "lg",
                class: "w-full",
                disabled: isLoggingOut.value,
                onClick: handleLogout
              }, {
                default: _withCtx(() => [
                  (isLoggingOut.value)
                    ? (_openBlock(), _createBlock(_unref(LoaderCircle), {
                        key: 0,
                        class: "size-4 animate-spin"
                      }))
                    : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(isLoggingOut.value ? 'Logging out...' : 'I understand'), 1))
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})